<div class="table-responsive small">

  <!-- Loading -->
  <ng-container *ngIf="areContactsLoading">
    <div class="loading-cover">
      <fa-icon class="me-2" [icon]="faCircleNotch" [spin]="true"></fa-icon> Loading
    </div>
  </ng-container>

  <!-- Error -->
  <ng-container *ngIf="!areContactsLoading && areContactsError">
    <p class="text-bg-danger rounded p-2 mt-3">Error: Contact history information couldn't be loaded.</p>
  </ng-container>

  <!-- Loaded -->
  <ng-container *ngIf="!areContactsLoading && !areContactsError">

    <!-- No model returned -->
    <ng-container *ngIf="!surveyContact">
      <p class="rem1 mt-3">There are no contact history records to show.</p>
    </ng-container>

    <!-- Model returned -->
    <ng-container *ngIf="surveyContact">

      <!-- No results -->
      <ng-container *ngIf="surveyContact.contactHistories!.length === 0">
        <p class="rem1 mt-3">There are no contact history records
          to show.</p>
      </ng-container>

      <!-- Results -->
      <ng-container *ngIf="surveyContact.contactHistories!.length > 0">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">Status</th>
              <th scope="col">Date</th>
              <th scope="col">Rep</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let m of surveyContact.contactHistories!">
              <td>{{ m.surveyContactType!.name }}</td>
              <td>{{ m.contactDate! | formatUtcDate }}</td>
              <td><span data-private>{{ m.clientRep ? m.clientRep.name : '' }}</span></td>
              <td><a class="btn btn-link btn-sm p-0 m-0" 
                      [hidden]="!this.accountInfo?.isAdmin" 
                      (click)="deleteSurveyContactHistory(m)">Delete</a>
          </td>
            </tr>
          </tbody>
        </table>
      </ng-container>

    </ng-container>



  </ng-container>



</div>